import { statusMeta } from "@/lib/screenBindings";

/** Iter 45 — bound / ambiguous / unresolved pill with the confidence beside it. */
export default function BindingStatusBadge({ status, confidence, testid }) {
  const m = statusMeta(status);
  return (
    <span className="inline-flex items-center gap-1" data-testid={testid} data-status={status} data-confidence={confidence}>
      <span
        className="ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap"
        style={{ background: m.bg, color: m.fg, borderColor: m.border, borderStyle: status === "bound" ? "solid" : "dashed" }}
        title={m.wording}
      >
        {m.label}
      </span>
      {confidence && (
        <span className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">{confidence}</span>
      )}
    </span>
  );
}
